import {createSelector} from 'reselect';

import {AppState} from './reducers';

export const userInfoSelector = (state: AppState) => state.userInfo;
export const preRegisterSelector = (state: AppState) => state.preRegister;

// onboarding revamp selector
export const countryCodeSelector = createSelector(userInfoSelector, item => item.countryCode);
export const mobileSelector = createSelector(userInfoSelector, item => item.mobile);

export const directLandingSelector = createSelector(userInfoSelector, item => item.directLanding);
export const errorSelector = createSelector(userInfoSelector, item => item.error);
export const kycModalSelector = createSelector(userInfoSelector, item => item.updatedKYCModal);

export const titleSelector = createSelector(userInfoSelector, item => item.title);
export const fullnameSelector = createSelector(userInfoSelector, item => item.fullName);

export const emailSelector = createSelector(userInfoSelector, item => item.email);

export const account_existsSelector = createSelector(userInfoSelector, item => item.account_exists);
export const verify_mmt_passwordSelector = createSelector(
  userInfoSelector,
  item => item.verify_mmt_password,
);
export const account_existsMessageSelector = createSelector(userInfoSelector, item => item.message);
export const mobileWithCodeSelector = createSelector(
  userInfoSelector,
  item => `${item.countryCode}-${item.mobile}`,
);
export const tokenSelector = createSelector(userInfoSelector, item => item.token);
export const tncLinkSelector = createSelector(userInfoSelector, item => item.tncLink);
export const businessTypeListSelector = createSelector(
  userInfoSelector,
  item => item.businessTypeList,
);
export const formFieldsSelector = createSelector(
  userInfoSelector,
  userInfo => userInfo?.formFieldData || {},
);
export const docTypeListSelector = createSelector(userInfoSelector, item => item.docTypeList);
export const statusSelector = createSelector(userInfoSelector, item => item.status);
export const sessionExpireSelector = createSelector(userInfoSelector, item => item.sessionExpire);

export const agencyNameSelector = createSelector(userInfoSelector, item => item.agencyName);
export const panNumberSelector = createSelector(userInfoSelector, item => item.panNumber);
export const panUploadedSelector = createSelector(userInfoSelector, item => item.panUploaded);
export const panInfoSelector = createSelector(userInfoSelector, item => item.panInfo);
export const gstNumberSelector = createSelector(userInfoSelector, item => item.gstNumber);
export const businessTypeSelector = createSelector(userInfoSelector, item => item.businessType);
export const addressSelector = createSelector(userInfoSelector, item => item.address);
export const stateSelector = createSelector(userInfoSelector, item => item.state);
export const citySelector = createSelector(userInfoSelector, item => item.city);
export const pincodeSelector = createSelector(userInfoSelector, item => item.pincode);
export const kycUploadedSelector = createSelector(userInfoSelector, item => item.kycUploaded);
export const kycDocTypeSelector = createSelector(userInfoSelector, item => item.kycDocType);

export const panUploadSuccessSelector = createSelector(userInfoSelector, item => item.panSuccess);
export const panNameSelector = createSelector(userInfoSelector, item => item.pan_name);
export const panTypeSelector = createSelector(userInfoSelector, item => item.pan_type);
export const userMsgSelector = createSelector(userInfoSelector, item => item.user_msg);

export const nextLoader = createSelector(userInfoSelector, item => item.nextLoad);
export const gstLoaderSelector = createSelector(userInfoSelector, item => item.gstLoad);

export const mobileCount = createSelector(userInfoSelector, item => item.mobile_count);
export const emailCount = createSelector(userInfoSelector, item => item.email_count);

export const additionalDocSelector = createSelector(userInfoSelector, item => item.additionalDoc);

export const userDataSelector = createSelector(userInfoSelector, item => {
  const {
    title,
    fullName,
    countryCode,
    mobile,
    email,
    requestIp,
    accountId,
    ed_license_number,
    agencyName,
    address,
  } = item;
  return {
    title,
    fullName,
    countryCode,
    mobile,
    email,
    requestIp,
    accountId,
    ed_license_number,
    agencyName,
    address,
  };
});

export const prevPageNameSelector = createSelector(userInfoSelector, item => {
  const {prevPageName} = item;
  return {prevPageName};
});

export const userDetailsSelector = createSelector(userInfoSelector, item => {
  const {
    agencyName,
    panNumber,
    panUploaded,
    panInfo,
    gstNumber,
    businessType,
    address,
    state,
    city,
    pincode,
    kycUploaded,
    kycDocType,
    panSuccess,
    pan_name,
    pan_type,
    user_msg,
    facadeUploaded,
    ed_license_number,
    agency_name,
    email,
  } = item;
  return {
    agencyName,
    panNumber,
    panUploaded,
    panInfo,
    gstNumber,
    businessType,
    address,
    state,
    city,
    pincode,
    kycUploaded,
    kycDocType,
    panSuccess,
    pan_name,
    pan_type,
    user_msg,
    facadeUploaded,
    ed_license_number,
    agency_name,
    email,
  };
});

export const UserDataSelector = createSelector(userInfoSelector, item => {
  const {title, fullName, email, countryCode, mobile} = item;
  return {title, fullName, email, countryCode, mobile};
});

// new flow selectors

export const UserNumberSelector = createSelector(userInfoSelector, item => {
  const {countryCode, mobile} = item;
  return {
    countryCode,
    mobile,
  };
});

export const disabledBtnSelector = createSelector(userInfoSelector, item => item.btnDisabled);
export const headingSelector = createSelector(userInfoSelector, item => {
  const {otpheading, otpSubheading} = item;
  return {
    otpheading,
    otpSubheading,
  };
});
export const existingUserSelector = createSelector(userInfoSelector, item => item.exisitngUser);
export const nextScreenSelector = createSelector(userInfoSelector, item => item.nextScreen);
export const userDetailsNewSelector = createSelector(userInfoSelector, item => {
  const {
    title,
    fullName,
    email,
    agencyName,
    panNumber,
    panUploaded,
    panInfo,
    gstNumber,
    businessType,
    address,
    state,
    city,
    pincode,
    panSuccess,
    pan_name,
    pan_type,
    user_msg,
  } = item;
  return {
    title,
    fullName,
    email,
    agencyName,
    panNumber,
    panUploaded,
    panInfo,
    gstNumber,
    businessType,
    address,
    state,
    city,
    pincode,
    panSuccess,
    pan_name,
    pan_type,
    user_msg,
  };
});

export const kycDocumentSelector = createSelector(userInfoSelector, item => {
  const {kycUploaded, kycDocType, facadeUploaded, additionalDoc} = item;
  return {
    kycUploaded,
    kycDocType,
    facadeUploaded,
    additionalDoc,
  };
});
export const mpnfoSelector = createSelector(userInfoSelector, item => item.mpnfo);
export const nofSelector = createSelector(userInfoSelector, item => item.nof);
export const loginLoadSelector = createSelector(userInfoSelector, item => item.loginLoad);
export const userCountrySelector = createSelector(userInfoSelector, item => false);
export const authTokenSelector = createSelector(userInfoSelector, item => item.auth_token);
export const facadeUploadedSelector = createSelector(userInfoSelector, item => item.facadeUploaded);

export const lobSelector = createSelector(userInfoSelector, item => item?.lob?.toLowerCase() || '');
